export enum GaTrackingEventName {
  AddToCart = 'addToCart',
  AddToCartMoreThanInStock = 'over_stock_quantity_message',
  AlternativeProducts = 'alternative_products',
  SearchCorrected = 'search_corrected',
  Navigation = 'Navigation',
  ChangeQuantity = 'change_quantity',
  EditorialLinkNavigationClick = 'click_editorialLinkNavigation',
  Errors = 'Errors',
  CartUpdate = 'cart_update',
  Checkout = 'checkout',
  ContentBanner = 'content_banner_click',
  CheckoutStepper = 'checkout_stepper',
  CustomLinkedGrid = 'click_customLinkedGrid',
  SearchFiltered = 'search_filtered',
  CategoryPageFiltered = 'category_page_filtered',
  HomepageView = 'HPview',
  ListView = 'listView',
  Logout = 'logout',
  Notifications = 'Notifications',
  PdpDescriptionInteraction = 'PDP description interaction',
  PdpLoadbeeClick = 'loadbee_button_click',
  PdpCompareAllOffersClick = 'compare_all_offers_click',
  PdpFurtherInformationClick = 'further_information_click',
  PdpImageInteraction = 'PDP image interaction',
  PromoClick = 'PromoClick',
  ProductClick = 'productClick',
  PDPview = 'PDPview',
  PromoView = 'PromoView',
  Purchase = 'purchase',
  PurchaseGA4 = 'purchase_ga4',
  RemoveFromCart = 'removeFromCart',
  RemoveSearchFiltered = 'remove_filters',
  Search = 'search',
  CategoryPage = 'Category Page',
  SearchBarInteraction = 'search_search bar interaction',
  SearchSuggestion = 'search_suggestion',
  SearchZeroResult = 'search_0_results',
  CategoryPageZeroResult = 'category_page_0_results',
  SeoFaqToggle = 'contentFAQ',
  VolumePricingClick = 'volume pricing click',
  PricetypePopupAccepted = 'pricetype_popup_accepted',
  PriceToggler = 'price_toggler',
  ProductsSorted = 'sorting_dropdown',
  PromoImageLinkClick = 'click_salesNavigationBanner',
  VolumePricingTableClicked = 'volume-pricing-table',
  PLPPagination = 'PLP_pagination',
  PLPShowMoreProducts = 'PLP_20_more_products',
  OutOfStockNotifyClick = 'out-of-stock_notify_click',
  ExploreSimilarProductsClick = 'out-of-stock_similar_products_click',
  PdpBrandInteraction = 'PDP brand interaction',
  PdpSellerInteraction = 'PDP seller interaction',
  PdpOtherOffersInteraction = 'offer_picker',
  PLPSeoText = 'SEOtextPLP',
  GoToCart = 'goToCart',
  ContactSeller = 'contactSeller',
  GetInvoices = 'getInvoices',
  ReturnProduct = 'returnProduct',
  CancelProduct = 'cancelProduct',
  CancelOrder = 'cancelOrder',
  NavigateToSeller = 'navigateToSeller',
  NavigateToDeliveryCarrier = 'navigateToDeliveryCarrier',
  FilterArea = 'FilterArea',
  PLPPriceFilter = 'PriceFilter',
  PDPRegisterAsBusiness = 'PDP register as a business',
  MiniCart = 'mini_cart',
  PageView = 'Page View',
  LoadBeeView = 'LoadbeeView',
  ProceedToCheckout = 'proceedToCheckout',
  CarouselSwipe = 'carouselSwipe',
  RegistrationTypeClicked = 'registrationTypeClicked',
  RegisterWithEmailButtonClicked = 'Register With Email Button Clicked',
  OfferPriceSync = 'Offer Price Sync',
  NewsletterSubscription = 'newsletter_subscription',
  HubPageCardClick = 'hubPage_cardClick',
  FeatureFlag = 'feature_flag',
  PdpOfferMismatch = 'pdp_offer_mismatch',
  FlixMediaContentView = 'FlixmediaView',
  FlixMediaContentScroll = 'flixmedia_content_scroll',
  FlixMediaBrandPageView = 'FlixmediaView',
  FlixMediaError = 'flixmedia_error',
  OptimizelyActivateExperiment = 'activate_experiment',
  OrderHistoryInteraction = 'interaction_order_history',
  PdpWeeMoreDetailsInteraction = 'weee_details_click',
  BuyAgain = 'buy_again',
  BuyAgainHeaderInteraction = 'header buy again link interaction',
  ApprovalsHeaderLinkClick = 'se_approvals_header_link_clicked',
  ShoppingListHeaderInteraction = 'header shopping list link interaction',
  YourAssortmentHeaderInteraction = 'header your assortment link interaction',
  ExploreSimilarProductsBuyAgainClickInteraction = 'explore_similar_products_click_buy_again',
  ContentCardClick = 'clickContentCard',
  CategoryCardClick = 'clickCategoryCard',
  Ecommerce = 'Ecommerce',
  ViewItem = 'view_item',
  AddToCartGa4 = 'add_to_cart',
  ViewRecommendation = 'view_recommendation',
  SelectRecommendation = 'select_recommendation',
  InstallationServices = 'Service Installation Checkbox',
  InstallationServicesDetails = 'Service Installation Details',
  InstallationServicesDetailsLinks = 'Service Installation Link Click',
  ShowTooltipValueAddedService = 'show_tooltip_vas',
  HeroBannerClick = 'clickHeroBanner',
  InvalidOfferForRegion = 'invalid_offer_for_region',
  BackToCart = 'back_to_cart',
  ChangeDeliveryAddress = 'change_delivery_address',
  ViewPromotion = 'view_promotion',
  ZRPCategoryClicked = 'category_clicked',
  Interaction = 'interaction',
  Filter = 'filter',
  GridNavigation = 'navigation',
  shoppingListHeaderButtonInteraction = 'se_sl_header_link_clicked',
}
